module.exports = __webpack_public_path__ + "static/media/digital-display.7b4b33da.svg";